var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('inspinia-ibox',{attrs:{"title":_vm.title}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('content-editor',{attrs:{"hasError":_vm.hasError,"content":_vm.value},on:{"input":_vm.onValueChanged}}),(_vm.hasError)?_c('label',{staticClass:"has-error"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }